import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../layout/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: Layout,
    name: 'index',
    redirect: 'home',
    children:[
      {
        path: '/',
        name: 'Home',
        component: () => import('../views/home/index.vue')
      },
      {
        path: '/researchTeam',
        name: 'ResearchTeam',
        component: () => import('../views/researchTeam/index.vue')
      },
      {
        path: '/economicForecasting',
        name: 'EconomicForecasting',
        component: () => import('../views/economicForecasting/index.vue')
      },
      {
        path: '/confidenceMonitoring',
        name: 'ConfidenceMonitoring',
        component: () => import('../views/confidenceMonitoring/index.vue')
      },
      {
        path: '/riskWarning',
        name: 'RiskWarning',
        component: () => import('../views/riskWarning/index.vue')
      },
      {
        path: '/policySimulation',
        name: 'PolicySimulation',
        component: () => import('../views/policySimulation/index.vue')
      }
    ]
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router